module.exports = __webpack_public_path__ + "static/media/ProcterAndGamble.77079c9e.png";